import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import getLocale from '../../../i18n/getLocale';

class StaffCostsTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: false,
      staff_id: this.props.staff_id,
      date_start: '',
      staff_costs: [],
      cost_center: null,
    };

    this.locale = getLocale();

    //bind específico
    this.add = this.add.bind(this);
    this.refreshData = this.refreshData.bind(this);
    this.activate = this.activate.bind(this);
    this.archive = this.archive.bind(this);
    this.delete = this.delete.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.staff_costs) && this.state.loaded === false) {
      this.setState({
        staff_costs: newProps.staff_costs,
        loaded: true
      });
    }
  }

  // Fetch salvando a edição
  add(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      staff_id: this.state.staff_id,
      cost_center: this.state.cost_center,
      date_start: this.state.date_start,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/funcionario/custo', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.refreshData();
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  // Fetch ativando um item
  activate(event) {
    var id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Tripulantes.EditarFuncionario.tabCentroDeCusto.ativar);
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var datasave = {
        id: id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/funcionario/custo/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.refreshData();
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  // Fetch deletando um item
  archive(event) {
    var id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Tripulantes.EditarFuncionario.tabCentroDeCusto.arquivar);
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/funcionario/custo/arquivar/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.refreshData();
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }
  // Fetch deletando um item
  delete(event) {
    var id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Tripulantes.EditarFuncionario.tabCentroDeCusto.deletar);
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/funcionario/custo/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.refreshData();
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  refreshData () {
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/funcionario/custos/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.setState({staff_costs: responseJson.data});
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">{this.locale.Tripulantes.EditarFuncionario.tabCentroDeCusto.tituloCentroDeCusto}</h3>
  <hr/>
  {(this.state.staff_costs === null || typeof this.state.staff_costs === 'undefined') ?  <div><small><em>{this.locale.Tripulantes.EditarFuncionario.tabCentroDeCusto.nenhumCentroDeCustoCadastrado}</em></small><hr/></div>
  :
  <div>
    <table className="table table-bordered table-stripped table-hover">
      <thead>
        <tr>
          <th className="text-center">{this.locale.Tripulantes.EditarFuncionario.tabCentroDeCusto.tabela.CentroDeCusto}</th>
          <th className="text-center">{this.locale.Tripulantes.EditarFuncionario.tabCentroDeCusto.tabela.Data}</th>
          <th className="col-md-1 text-center">{this.locale.Tripulantes.EditarFuncionario.tabCentroDeCusto.tabela.Status}</th>
          <th className="col-md-1 text-center">{this.locale.Tripulantes.EditarFuncionario.tabCentroDeCusto.tabela.Acoes}</th>
        </tr>
      </thead>
      <tbody id="staff-costs">
        {Object.keys(self.state.staff_costs).map(function(k) {
          return (
            <tr>
              <td className="text-center">{self.state.staff_costs[k].cost_center}</td>
              <td className="text-center">{self.state.staff_costs[k].date_start_str}</td>
              <td className="text-center">{(self.state.staff_costs[k].active === 1) ?  <span className="label label-success">{self.locale.Tripulantes.EditarFuncionario.tabCentroDeCusto.tabela.Ativo}</span> : <span className="label label-danger">{self.locale.Tripulantes.EditarFuncionario.tabCentroDeCusto.tabela.Arquivado}</span>}</td>
              <td className="text-center">
                {(self.state.staff_costs[k].active === 1) ?
                  <button className="btn btn-sm btn-danger" value={self.state.staff_costs[k].id} onClick={self.archive}><i className="fa fa-fw fa-power-off"></i></button>
                  :
                  <button className="btn btn-sm btn-success" value={self.state.staff_costs[k].id} onClick={self.activate}><i className="fa fa-fw fa-power-off"></i></button>
                }
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
    <hr/>
  </div>
  }
  <h3 className="page-title">{this.locale.Tripulantes.EditarFuncionario.tabCentroDeCusto.tituloCadastrarCentroDeCusto}</h3>
  <hr/>
  <form onSubmit={this.add}>
    <div className="row">
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabCentroDeCusto.formulario.CentroDeCusto}:</label>
        <input type="text" className="form-control" name="cost_center" value={this.state.cost_center} onChange={this.handleChange.bind(this, 'cost_center')} />
      </div>
      <div className="col-md-6 form-group">
        <label>{this.locale.Tripulantes.EditarFuncionario.tabCentroDeCusto.formulario.DataInicial}:</label>
        <InputMask value={this.state.date_start}  maskChar={null} name="date_start" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder="" />
      </div>
    </div>
    <hr/>
    <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Tripulantes.EditarFuncionario.tabCentroDeCusto.formulario.botaoSalvarCentroDeCusto}</button>
  </form>
</div>
    );
  }
}

export default StaffCostsTab;



// WEBPACK FOOTER //
// ./src/Components/Staffs/Elements/StaffCostsTab.js